import _ from 'lodash';

import {
  INFLUENCERS_URL,
  EDIT_PROFILE_URL,
  SOLUTIONS_URL,
  COMPANIES_URL
} from 'global-constants';

const PROFILE_COMPLETION_FIELDS = [
  'profile.first_name',
  'country',
  'profile.avatar',
  'user_type',
  'sectors',
  'connection_count',
  'following_solutions_count'
];

export const FIELDNAME_TO_DISPLAYNAME = {
  'profile.first_name': { label: 'Add your name', url: EDIT_PROFILE_URL },
  country: { label: 'Add your country', url: EDIT_PROFILE_URL },
  'profile.avatar': { label: 'Add your avatar', url: EDIT_PROFILE_URL },
  user_type: { label: 'Select your role', url: EDIT_PROFILE_URL },
  sectors: { label: 'Select your sectors', url: EDIT_PROFILE_URL },
  lifecycle: { label: 'Select your Lifecycle', url: EDIT_PROFILE_URL },
  service_areas: { label: 'Select your Service Types', url: EDIT_PROFILE_URL },
  connection_count: {
    label: 'Connect with an Influencer',
    url: INFLUENCERS_URL
  },
  following_solutions_count: { label: 'Follow a Solution', url: SOLUTIONS_URL },
  company: { label: 'Join a team', url: COMPANIES_URL }
};

export const getMissingFields = user => {
  const user_type = _.get(user, 'user_type.label', '');
  let fields = PROFILE_COMPLETION_FIELDS;

  if (user_type === 'Service Provider')
    fields = [...PROFILE_COMPLETION_FIELDS, 'service_areas'];
  else {
    fields = [...PROFILE_COMPLETION_FIELDS, 'lifecycle'];
  }

  let missingFields = _.filter(fields, field => {
    const value = _.get(user, field, '');
    return value === 0 || _.isNil(value) || _.isEqual([], value);
  });

  if (
    _.isNil(user.vendor) &&
    _.isNil(user.service_provider) &&
    _.isNil(user.investor)
  ) {
    fields = [...fields, 'company']; // to keep the totalFieldsCount calculation correct
    missingFields = [...missingFields, 'company'];
  }

  return {
    totalFieldsCount: fields.length,
    missingFields
  };
};

export const calculateProfileStrengthPercentage = user => {
  const { totalFieldsCount, missingFields } = getMissingFields(user);
  return (
    100 *
    (1 - (missingFields.length * 1.0) / totalFieldsCount)
  ).toFixed();
};

export const getFieldsState = user => {
  const user_type = _.get(user, 'user_type.label', '');
  let fields = PROFILE_COMPLETION_FIELDS;

  if (user_type === 'Service Provider') fields = [...fields, 'service_areas'];
  else {
    fields = [...fields, 'lifecycle'];
  }

  // we do it here and not in the beginning because we want it to be last
  fields = [...fields, 'company'];

  const { missingFields } = getMissingFields(user);

  // if a field is not in the missing fields - it's completed
  const fieldsWithState = fields.map(field => ({
    field,
    completed: !_.includes(missingFields, field)
  }));

  return fieldsWithState;
};
